export default __webpack_public_path__ + "static/media/1881.45af18a5.png";